import React, { Component } from 'react';
import {
    Stack,
    IComboBoxOption,
    SelectableOptionMenuItemType,
    IStackTokens,
    IComboBoxStyles,
    VirtualizedComboBox
} from '@fluentui/react';

import { authProvider } from '../authProvider';
import axios from 'axios';

const options: IComboBoxOption[] = [
    { key: 'Header1', text: 'First heading', itemType: SelectableOptionMenuItemType.Header },
    { key: 'A', text: 'Option A' },
    { key: 'B', text: 'Option B' },
    { key: 'C', text: 'Option C' },
    { key: 'D', text: 'Option D' },
    { key: 'divider', text: '-', itemType: SelectableOptionMenuItemType.Divider },
    { key: 'Header2', text: 'Second heading', itemType: SelectableOptionMenuItemType.Header },
    { key: 'E', text: 'Option E' },
    { key: 'F', text: 'Option F', disabled: true },
    { key: 'G', text: 'Option G' },
    { key: 'H', text: 'Option H' },
    { key: 'I', text: 'Option I' },
    { key: 'J', text: 'Option J' },
];
// Optional styling to make the example look nicer
const comboBoxStyles: Partial<IComboBoxStyles> = { root: { minWidth: 300, maxWidth: 500 } };
const stackTokens: Partial<IStackTokens> = { childrenGap: 20 };


export class CompanyCombo extends Component {
    static displayName = CompanyCombo.name;

    constructor(props) {
        super(props);
        var rootUrl = window.location.protocol + '//' + window.location.host + '/';
        this.state = {
            companies: [], token: '', headers: {}, rootUrl: rootUrl };
        this.get_companies = this.get_companies.bind(this);
    }

    componentDidMount() {
        var self = this;
        authProvider.getAccessToken().then(function (result) {

            var tkn = result.accessToken;

            if (tkn) {

                self.setState({ token: tkn, headers: { 'Authorization': "Bearer " + tkn },  });
                self.get_companies();
                
            }
            else {
                console.log("Token not acquired!")
            }
        })
    }
    get_companies() {
        axios.get(this.state.rootUrl + "CwCompany", { headers: this.state.headers }).then(res => {
            var companies = res.data;
            if (companies) {
                var options = companies.map((itm, ind) => {
                    return { key: itm.id, text: itm.name };
                });
                this.setState({ companies: options });
            }
        })
    }
    render() {
        return (
            <Stack horizontal tokens={stackTokens}>
                <VirtualizedComboBox
                    selectedKey={this.props.selectedKey}
                    label="Company"
                    allowFreeform={false}
                    autoComplete={'on'}
                    options={this.state.companies}
                    styles={comboBoxStyles}
                    onChange={this.props.onChange}
                />
                
            </Stack>
        );
    }
}
